import AOS from "aos";
import 'aos/dist/aos.css';
import { hideMenu, toggleMobileMenu, megicLine } from './modules/menuToggle';
import { videoLazyLoading } from './modules/videoLazyLoading';
import { smoothScroll } from "./modules/smoothScroll";
import { progressBar } from "./modules/progressBar";
import { debounce } from "./utils/delays";
import { handleFormSubmit } from './modules/form';

const windowWidth = window.innerWidth;
const header = document.querySelector('.header');
const navbarToggler = header?.querySelector('.nav-toggler');
const navMainMenu = header?.querySelector('.nav-main__menu');
const preloader = document.querySelector('.preloader');
const svg_preloader = preloader?.querySelector('svg');
const scrollToTopBtn = document.querySelector('.scroll-to-top');
const lazyVideos = document.querySelectorAll('video.lazy');

document.addEventListener("DOMContentLoaded", function() {
  (navbarToggler && header) && toggleMobileMenu(navbarToggler, header);
  navMainMenu && megicLine(navMainMenu);
  handleFormSubmit().init();
})

window.addEventListener('resize', () => {
  debounce((window.innerWidth != windowWidth && window.innerWidth >= 1025 && navbarToggler.classList.contains('menu-open')) && hideMenu(navbarToggler, header), 100);
});

window.onload = () => {
  AOS.init({
    duration: 500,
    easing: "ease-in-out",
    anchorPlacement: 'top-center',
  });
  smoothScroll(scrollToTopBtn);
  progressBar();
  lazyVideos.length > 0 && videoLazyLoading(lazyVideos);

  if(preloader) {
    svg_preloader.classList.add('active');
    setTimeout(() => { preloader.classList.add('hide'); }, 3200);
    setTimeout(() => { preloader.remove() }, 3600);
  }
};
